<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
    <div class="container-header-inner-list">

        <div class="row mb-4">
            <div class="col-12 col-md-6">
                <div class="title-wrapper">
                    <h1 class="title-default">Lista de Preços</h1>
                    <p class="welcome-message welcome-message--with-back">
                        <button mat-icon-button routerLink="/configuracoes/cadastros">
                            <mat-icon>arrow_back</mat-icon>
                        </button>
                        <span>Gerenciamento de Tabelas de Preços</span>
                    </p>
                </div>
            </div>
            <div class="col-12 col-md-6 header-actions">
                <button mat-stroked-button class="btn-secondary" [matMenuTriggerFor]="opcoesMenu">
                    @if(selection.hasValue()) {
                    <span>Ações ({{selection.selected.length}})</span>
                    } @else {
                    <span>Ações</span>
                    }
                    <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
                </button>

                <mat-menu #opcoesMenu="matMenu">
                    <button mat-menu-item (click)="abrirModalExcluirEmMassa()" [disabled]="!selection.hasValue()">
                        <mat-icon class="material-symbols-outlined">delete</mat-icon>
                        <span>Excluir selecionados</span>
                    </button>
                </mat-menu>

                <a type="button" mat-flat-button class="btn-primary"
                    routerLink="/configuracoes/cadastros/lista-precos/cadastrar">
                    <mat-icon>add</mat-icon>
                    Nova Lista de Preços
                </a>
            </div>
        </div>
        <form class="form" [formGroup]="model" (ngSubmit)="clickPesquisar()" class="search-area">
            <div class="row">
                <div class="col-12 col-lg-6">
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Pesquisar por nome...</mat-label>
                        <input matInput formControlName="pesquisa" type="text">
                        <button mat-icon-button matSuffix type="button" (click)="clickPesquisar()"
                            aria-label="Pesquisar">
                            <mat-icon>search</mat-icon>
                        </button>
                    </mat-form-field>
                </div>
            </div>
        </form>

        @if(this._listaPrecoResponse && this._listaPrecoResponse.listaPrecos.length > 0){
        <table mat-table class="desktop-view" [dataSource]="_dataSource" matSort>

            <!-- Checkbox Column -->
            <ng-container matColumnDef="select">
                <th mat-header-cell *matHeaderCellDef class="w-checkbox">
                    <mat-checkbox (change)="$event ? masterToggle() : null"
                        [checked]="selection.hasValue() && isAllSelected()" [aria-label]="checkboxLabel()">
                    </mat-checkbox>
                </th>
                <td mat-cell *matCellDef="let row" class="w-checkbox">
                    @if (row.isPadrao) {
                    <span class="row-lock-wrapper">
                        <span class="material-symbols-outlined row-lock-icon"
                            matTooltip="Lista padrão não pode ser selecionada">
                            lock
                        </span>
                    </span>
                    } @else {
                    <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null"
                        [checked]="selection.isSelected(row)" [aria-label]="checkboxLabel(row)">
                    </mat-checkbox>
                    }
                </td>
            </ng-container>

            <!-- Descrição Column -->
            <ng-container matColumnDef="descricao">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Descrição </th>
                <td mat-cell *matCellDef="let element">
                    @if(element.isPadrao) {
                    <span class="status-badge badge-cinza ">Padrão</span>
                    }
                    {{element.descricao}}
                </td>
            </ng-container>

            <!-- Início Vigência Column -->
            <ng-container matColumnDef="dataInicioVigencia">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Início Vigência </th>
                <td mat-cell *matCellDef="let element"> {{element.dataInicioVigencia | date: 'dd/MM/yyyy'}} </td>
            </ng-container>

            <!-- Término Vigência Column -->
            <ng-container matColumnDef="dataTerminoVigencia">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Término Vigência </th>
                <td mat-cell *matCellDef="let element">
                    {{ element.dataTerminoVigencia ? (element.dataTerminoVigencia | date: 'dd/MM/yyyy') :
                    'Indeterminado' }}
                </td>
            </ng-container>

            <!-- Método de Ajuste Column -->
            <ng-container matColumnDef="metodoAjustePreco">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Método de Ajuste </th>
                <td mat-cell *matCellDef="let element"> {{element.metodoAjustePreco}} </td>
            </ng-container>

            <!-- Promoção Column -->
            <ng-container matColumnDef="isPromocao">
                <th mat-header-cell *matHeaderCellDef class="text-center"> Promoção </th>
                <td mat-cell *matCellDef="let element" class="text-center">
                    @if (element.isPromocao) {
                    <span matTooltip="Lista de promoção" class="status-badge badge-verde">Promoção</span>
                    }
                </td>
            </ng-container>

            <!-- Actions Column -->
            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef class="text-center w-actions">Ações</th>
                <td mat-cell *matCellDef="let element" class="text-center w-actions">
                    <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Ações">
                        <span class="material-symbols-outlined">more_horiz</span>
                    </button>
                    <mat-menu #menu="matMenu">
                        <button mat-menu-item
                            [routerLink]="['/configuracoes/cadastros/lista-precos/cadastrar', {id: element.idListaPreco}]">
                            <span class="material-symbols-outlined">{{ element.isPadrao ? 'visibility' : 'edit'
                                }}</span>
                            <span>{{ element.isPadrao ? 'Visualizar' : 'Editar' }}</span>
                        </button>
                        <span [matTooltip]="element.isPadrao ? 'Você não pode excluir a lista de preço padrão' : ''"
                            [matTooltipDisabled]="!element.isPadrao">
                            <button mat-menu-item [disabled]="element.isPadrao"
                                (click)="abrirModalExcluir(element.idListaPreco, element.descricao)">
                                <span class="material-symbols-outlined">delete</span>
                                <span>Excluir</span>
                            </button>
                        </span>
                    </mat-menu>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>

        <div class="mobile-view">
            @for (row of _dataSource.data; track row.idListaPreco) {
            <div class="card-mobile mb-3" [class.selected-card]="selection.isSelected(row)">
                <div class="card-header-mobile d-flex justify-content-between align-items-center">
                    <div class="d-flex align-items-center gap-2">
                        @if (row.isPadrao) {
                        <span class="material-symbols-outlined row-lock-icon"
                            matTooltip="Lista padrão não pode ser selecionada">lock</span>
                        } @else {
                        <mat-checkbox (click)="$event.stopPropagation()"
                            (change)="$event ? selection.toggle(row) : null" [checked]="selection.isSelected(row)">
                        </mat-checkbox>
                        }
                        <div class="d-flex flex-column">
                            <span class="text-bold">
                                @if (row.isPadrao) {
                                <span class="status-badge badge-cinza">Padrão</span>
                                }
                                {{ row.descricao }}
                            </span>
                        </div>
                    </div>
                    <button mat-icon-button [matMenuTriggerFor]="menuMobile">
                        <span class="material-symbols-outlined">more_horiz</span>
                    </button>
                    <mat-menu #menuMobile="matMenu">
                        <button mat-menu-item
                            [routerLink]="['/configuracoes/cadastros/lista-precos/cadastrar', {id: row.idListaPreco}]">
                            <span class="material-symbols-outlined">{{ row.isPadrao ? 'visibility' : 'edit' }}</span>
                            <span>{{ row.isPadrao ? 'Visualizar' : 'Editar' }}</span>
                        </button>
                        <button mat-menu-item [disabled]="row.isPadrao"
                            (click)="abrirModalExcluir(row.idListaPreco, row.descricao)">
                            <span class="material-symbols-outlined">delete</span>
                            <span>Excluir</span>
                        </button>
                    </mat-menu>
                </div>
                <div class="card-body-mobile p-3">
                    <div class="row">
                        <div class="col-6 mb-2">
                            <small class="d-block">Início Vigência</small>
                            <span>{{ row.dataInicioVigencia | date: 'dd/MM/yyyy' }}</span>
                        </div>
                        <div class="col-6 mb-2">
                            <small class="d-block">Término Vigência</small>
                            <span>{{ row.dataTerminoVigencia ? (row.dataTerminoVigencia | date: 'dd/MM/yyyy') :
                                'Indeterminado' }}</span>
                        </div>
                        <div class="col-6 mb-2">
                            <small class="d-block">Método de Ajuste</small>
                            <span>{{ row.metodoAjustePreco }}</span>
                        </div>
                        @if (row.isPromocao) {
                        <div class="col-6 mb-2">
                            <span matTooltip="Lista de promoção" class="status-badge badge-verde">Promoção</span>
                        </div>
                        }
                    </div>
                </div>
            </div>
            }
        </div>

        <div class="col-12 text-center ver-mais-pesquisa">
            <button mat-button [disabled]="_ultimaPagina" (click)="proximaPagina()">
                @if (_isLoading === true) {
                <mat-spinner [diameter]="30" class="mat-spinner-btn"></mat-spinner>
                }
                @else{
                <span class="material-symbols-outlined">keyboard_arrow_down</span>
                Ver mais
                }
            </button>
        </div>
        }@else if(_isLoading === true){
        <app-loading-box-default-list></app-loading-box-default-list>
        }
        @else if(this._listaPrecoResponse?.listaPrecos?.length === 0){
        <app-empty-list [title]="'Não foi encontrada nenhuma lista de preços com o filtro informado'"></app-empty-list>
        }
    </div>
</div>